import { useTranslation } from "react-i18next";
import BarGraph from "./BarGraph";
import { determineAvg } from "../body-composition.helper";
import NoData from "./NoData";
import SvgIcon from "../../../../../parts/SvgIcon";
import { parseTime } from "../../sleep-time/SleepTime";

const Header = ({ date, athlete, organizationCoachParam }) => {
  const { t } = useTranslation("athlete-portal");
  return (
    <header>
      <div>
        <h4>{t("bodyComposition.sleep.title")}</h4>
        <p className="p4">{t("bodyComposition.averageForWeek")}</p>
      </div>
      <a
        className="composition-see-more mobile-hidden"
        href={`/athlete-portal/metrics/sleep-time?date=${date}&athlete=${athlete}&bodycomp=true${organizationCoachParam}`}
      >
        <span>{t("bodyComposition.seeMore")}</span>
        <SvgIcon
          src="/img/new-icons/arrow-square-right-gradient.svg"
          noFilterOnLight={true}
        />
      </a>
    </header>
  );
};

const Results = ({ data, avg, previousAverage }) => {
  const { t } = useTranslation("athlete-portal");
  const increase = avg - previousAverage || 0;
  const percentage =
    Math.round(((avg - previousAverage) / previousAverage) * 100) || 0;
  const isPositivePercentage = increase >= 0;

  const hasData = data.some((d) => !!d.sleep);

  return (
    <div>
      {hasData && (
        <div>
          <div>
            {!!previousAverage && (
              <span
                className={
                  isPositivePercentage ? "text-(--success)" : "text-(--danger)"
                }
              >
                <img
                  src={
                    isPositivePercentage
                      ? "/img/svg/green-up-icon.svg"
                      : "/img/svg/red-down-icon.svg"
                  }
                />{" "}
                {percentage}%
              </span>
            )}
            <div>
              <h1>{parseTime(avg)}</h1>
              <span className="composition-second-font">{t("bodyComposition.sleep.timeLabel")}</span>
            </div>
          </div>
        </div>
      )}
      <div className="adherence-chart-new">
        <BarGraph
          data={data}
          graphId={"sleep-graph"}
          targetValue={"sleep"}
          average={avg}
          parseFn={parseTime}
        />
      </div>
    </div>
  );
};

const SleepStats = ({
  data,
  date,
  athlete,
  previousWeek,
  organizationCoachParam,
}) => {
  const { t } = useTranslation("athlete-portal");
  const average = determineAvg(data, "sleep");
  const previousAverage = determineAvg(previousWeek, "sleep");

  return (
    <article id="steps-data">
      <Header
        date={date}
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />
      {data.length ? (
        <Results data={data} avg={average} previousAverage={previousAverage} />
      ) : (
        <NoData />
      )}
      <footer className="only-show-mobile">
        <a
          className="composition-see-more"
          href={`/athlete-portal/metrics/sleep-time?date=${date}&athlete=${athlete}&bodycomp=true${organizationCoachParam}`}
        >
          <span>{t("bodyComposition.seeMore")}</span>
          <SvgIcon
            src="/img/new-icons/arrow-square-right-gradient.svg"
            noFilterOnLight={true}
          />
        </a>
      </footer>
    </article>
  );
};

export default SleepStats;
